import React from 'react'
import { connect } from 'react-redux'
import { Form, Card } from 'react-bootstrap'

import {
  handleICUAdmissionFieldChange,
  submitICUAdmission,
  deleteICUAdmission,
  updateAssociatedField,
  handleAntibioticsUseChartFieldChange,
  deleteOrganSupport,
 } from '../reducers/antibioticsUseFormReducer'

 import {
   handleChartFieldChange,
 } from '../reducers/chartFormReducer'

import FormInput from '../../../components/FormInput'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import ConfirmationPopover from '../../../components/ConfirmationPopover'

import ICUAdmissionOrganSupportTable from './ICUAdmissionOrganSupportTable'

const ICUAdmission = (props) => {

  const {
    icu_admission_date,
    icu_discharge_date,
    icu_admission_reason,
    apache_ii_score_assessed,
    apache_ii_score,
    icu_discharge_description,
    patient_required_organ_support,
    chartForReview,
    chartDateErrorMessage,
    savingChartPhase,
  } = props


  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleICUAdmissionFieldChange(props.id, name, value)
  }

  const handleApacheScoreAssesedChange = (e) => {
    const { name, checked } = e.target
    props.handleICUAdmissionFieldChange(props.id, name, !checked)
    props.handleICUAdmissionFieldChange(props.id, 'apache_ii_score', '')
    const icuAdmission = {...props, [name]: !checked, apache_ii_score: ''}
    return props.submitICUAdmission(icuAdmission)
  }

  const handleDateChange = (name, date) => {
    props.handleICUAdmissionFieldChange(props.id, name, date)
    props.handleChartFieldChange('chartDateErrorMessage', '')

    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const icuAdmission = {...props, [name]: date, 'chartDateErrorMessage': name}
      return props.submitICUAdmission(icuAdmission)
    }
  }

  const handleBlur = () => {
    props.submitICUAdmission(props)
  }

  const handleRemove = () => {
    return props.deleteICUAdmission(props)
  }


  const getRequired = (key) => {
    let required = true
    if (props[`${key}`] !== null) {
      required = false
    }
    return required
  }

  const toggleOrganSupport = () => {
    const name = 'patient_required_organ_support'
    const value = !patient_required_organ_support
    let updatedIcuAdmissions = updateAssociatedField(props.id, name, value, props.icuAdmissions)
    props.handleAntibioticsUseChartFieldChange('icuAdmissions', updatedIcuAdmissions)
    props.organ_supports.forEach(support => {
      const supportDetails = {
        ...support,
        organ_supports: props.organ_supports,
        icuAdmissionId: props.id,
      }
      props.deleteOrganSupport(supportDetails)
    })
    return props.handleICUAdmissionFieldChange(props.id, name, value)
  }

  const icuDischargeDescriptionOptions = [
    {value: 'Transfer to the regular ward or another center'},
    {value: 'Died in ICU'},
    {value: 'Other'},
  ]

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let name = chartDateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const popoverContent = (
    <div>
      <p>Remove ICU Admission?</p>
      <br/>
      <p>This action will <strong>delete the ICU admission from the database</strong>.</p>
    </div>
  )

  return (
    <Card>
      <Card.Body>

        <FormInput
          label={"Date Entered ICU"}
          type={'date'}
          name={'icu_admission_date'}
          value={icu_admission_date}
          xs={12}
          sm={12}
          md={8}
          lg={6}
          onChange={(date) => handleDateChange('icu_admission_date', date)}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
          errorText={getHelperText('icu_admission_date')}
        />

        <FormInput
          label={"Date Left ICU"}
          type={'date'}
          name={'icu_discharge_date'}
          value={icu_discharge_date}
          xs={12}
          sm={12}
          md={8}
          lg={6}
          onChange={(date) => handleDateChange('icu_discharge_date', date)}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
          errorText={getHelperText('icu_discharge_date')}
        />

        <FormInput
          label="Why was the patient in ICU?"
          type='text'
          name='icu_admission_reason'
          value={icu_admission_reason}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="ICU admission reason"
          disabled={chartForReview}
          required={true}
        />

        <FormInput
          label="What was the APACHE II Score upon ICU admission?"
          type='number'
          name='apache_ii_score'
          value={apache_ii_score}
          readOnly={apache_ii_score_assessed === false}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="APACHE II Score"
          disabled={chartForReview}
          required={true}
          infoText='Do not calculate the APACHE II score if not reported in the chart'
         />

        <Form.Check
          label='APACHE II Score not assessed'
          id={'apache_ii_score_assessed'}
          name={'apache_ii_score_assessed'}
          checked={apache_ii_score_assessed === false}
          onBlur={handleBlur}
          onChange={handleApacheScoreAssesedChange}
          disabled={chartForReview || savingChartPhase}
          required={true}
        />

        <br/>

        <SelectWithOptionalTextField
          label='ICU discharge'
          options={icuDischargeDescriptionOptions}
          selected={icu_discharge_description}
          selectFieldName='icu_discharge_description'
          handleChange={handleChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />

        <br/>

        <Form.Label>
          Did patient require organ support in an ICU setting while on cefiderocol? (ICU setting includes the critical care received outside of the ICU).
        </Form.Label>
        <Form.Check
          id={`patientDidNotRequireOrganSupport${props.id}`}
          name={`patientDidNotRequireOrganSupport${props.id}`}
          label='No'
          type="radio"
          checked={patient_required_organ_support === false}
          onBlur={handleBlur}
          onChange={toggleOrganSupport}
          disabled={chartForReview}
          required={getRequired('patient_required_organ_support')}
        />

        <Form.Check
          id={`patientRequiredOrganSupport${props.id}`}
          name={`patientRequiredOrganSupport${props.id}`}
          label='Yes'
          type="radio"
          checked={patient_required_organ_support === true}
          onBlur={handleBlur}
          onChange={toggleOrganSupport}
          disabled={chartForReview}
          required={getRequired('patient_required_organ_support')}
        />

        {patient_required_organ_support ?
          <ICUAdmissionOrganSupportTable
            icuAdmissionId={props.id}
            icuAdmissionUrl={props.url}
            {...props}
          />
          :
          null
        }

        {chartForReview ?
          null
          :
          <>
            <br/>
            <ConfirmationPopover
              triggerText='Remove the Currently Selected ICU Admission'
              title='Delete ICU Admission?'
              placement='top'
              popoverContent={popoverContent}
              onConfirm={handleRemove}
            />
          </>
        }

      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return {
    antibiotics_use: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    savingChartPhase: state.chartFormReducer.savingChartPhase,
  }
}

const mapDispatchToProps = {
  handleICUAdmissionFieldChange,
  submitICUAdmission,
  deleteICUAdmission,
  handleChartFieldChange,
  updateAssociatedField,
  handleAntibioticsUseChartFieldChange,
  deleteOrganSupport,
}


export default connect(mapStateToProps, mapDispatchToProps)(ICUAdmission)
